(function () {
  const BREAKPOINT = 990; // adjust if your theme uses a different mobile breakpoint

  function updateSearchPlaceholder() {
    const inputs = document.querySelectorAll(
      'input[type="search"][placeholder-mobile][placeholder-desktop]'
    );
    const isMobile = window.innerWidth < BREAKPOINT;
    inputs.forEach((input) => {
      const mobilePlaceholder = input.getAttribute('placeholder-mobile');
      const desktopPlaceholder = input.getAttribute('placeholder-desktop');

      if (isMobile && mobilePlaceholder) {
        input.setAttribute('placeholder', mobilePlaceholder);
      } else if (!isMobile && desktopPlaceholder) {
        input.setAttribute('placeholder', desktopPlaceholder);
      }
    });
  }

  // Initial run
  updateSearchPlaceholder();

  // Update on resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateSearchPlaceholder, 150);
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest(
      '[data-ele="search-icon-right"], [data-ele="search-box-overlay"]'
    );

    if (!trigger) return;

    const searchBox = document.querySelector('.header__top .header__search');
    const body = document.body;
    const predictiveSearch = searchBox.querySelector('predictive-search');
    const searchContent = predictiveSearch?.querySelector('.search__content');

    const isOpen = searchBox.classList.contains('search-box-open');

    if (isOpen) {
      // 🔴 Removing class (CLOSING)

      searchBox.classList.remove('search-box-open');
      body.classList.remove('search-open');

      if (predictiveSearch) {
        predictiveSearch.classList.remove('predictive-search-open');
      }

      if (searchContent) {
        searchContent.classList.add('hidden');
      }

    } else {
      // 🟢 Adding class (OPENING)

      searchBox.classList.add('search-box-open');
    }
  });


  document.addEventListener('product-ajax:added', (event) => {
    console.log('Product Added Event:', event.detail);

    const product = event.detail.product;

    // Example
    console.log(product);
  });

  document.addEventListener('cart:refresh', (event) => {
    console.log('Cart Refresh Event:', event.detail);

    const { open } = event.detail;

    if (open) {
      console.log('Open cart drawer');
    }
  });

})();

(function () {
  if (!window.FoxTheme || !FoxTheme.pubsub) {
    return;
  }

  class TieredOfferBase extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.handleGroupedSections = this.handleGroupedSections.bind(this);
      this.handleCartUpdate = this.handleCartUpdate.bind(this);
    }

    connectedCallback() {
      document.addEventListener('cart:grouped-sections', this.handleGroupedSections);

      this.unsubscribeCartUpdate = FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        this.handleCartUpdate
      );
    }

    disconnectedCallback() {
      document.removeEventListener('cart:grouped-sections', this.handleGroupedSections);
      if (this.unsubscribeCartUpdate) {
        this.unsubscribeCartUpdate();
      }
    }

    handleGroupedSections(event) {
      if (!event.detail || !Array.isArray(event.detail.sections)) {
        return;
      }
      if (this.sectionId) {
        event.detail.sections.push(this.sectionId);
      }
    }

    handleCartUpdate(event) {
      try {
        const cart = event?.cart;

        if (!cart || !cart.sections || !this.sectionId) {
          return;
        }

        const sectionHTML = cart.sections[this.sectionId];
        if (!sectionHTML) {
          return;
        }

        const parsedHTML = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const tagName = this.tagName.toLowerCase();

        const updatedElement = parsedHTML.querySelector(
          `${tagName}[data-section-id="${this.sectionId}"]`
        );

        if (!updatedElement) {
          return;
        }

        this.innerHTML = updatedElement.innerHTML;

        this.dispatchEvent(
          new CustomEvent(`${tagName}:updated`, {
            detail: { cart },
          })
        );
      } catch (error) {
        console.error('Tiered offer update failed:', error);
      }
    }
  }

  // Two thin subclasses — Web Components spec requires one class per tag name
  class TieredOffer extends TieredOfferBase {}
  class TieredOfferTable extends TieredOfferBase {}

  customElements.define('tiered-offer', TieredOffer);
  customElements.define('tiered-offer-table', TieredOfferTable);
})();